import { NgModule } from '@angular/core';
import { SharedModule } from './../shared/shared.module';

import { AccountRoutingModule } from './account-routing.module';
import { AccountComponent } from './account.component';
import { LoginComponent } from './components/login/login.component';
import { SignupComponent } from './components/signup/signup.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ConfirmEmailComponent } from './components/confirm-email/confirm-email.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { HeaderComponent } from './components/header/header.component';
import { SignupSuccessComponent } from './components/signup-success/signup-success.component';
import { ResendConfirmLinkComponent } from './components/resend-confirm-link/resend-confirm-link.component';


@NgModule({
  declarations: [
    AccountComponent,
    SignupComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ConfirmEmailComponent,
    HeaderComponent,
    SignupSuccessComponent,
    ResendConfirmLinkComponent
  ],
  imports: [
    AccountRoutingModule,
    SharedModule
  ]
})
export class AccountModule { }
